import React from 'react';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { X, Trash2, FolderInput } from 'lucide-react';

interface Folder {
    id: number;
    name: string;
}

interface BulkActionsProps {
    selectedCount: number;
    onClearSelection: () => void;
    onDelete: () => void;
    folders: Folder[];
    currentFolderId?: number;
    onMove: (folderId: number | null) => void;
}

export default function BulkActions({
    selectedCount,
    onClearSelection,
    onDelete,
    folders,
    currentFolderId,
    onMove,
}: BulkActionsProps) {
    return (
        <div className="mb-4 p-3 bg-primary/10 border border-primary rounded-lg flex items-center justify-between">
            <div className="flex items-center gap-2">
                <span className="font-medium">{selectedCount} file(s) selected</span>
            </div>

            <div className="flex items-center gap-2">
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="outline" size="sm">
                            <FolderInput className="h-4 w-4 mr-2" />
                            Move to...
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-56">
                        {currentFolderId && (
                            <DropdownMenuItem onClick={() => onMove(null)}>
                                📁 Root folder
                            </DropdownMenuItem>
                        )}
                        {folders
                            .filter(f => f.id !== currentFolderId)
                            .map(folder => (
                                <DropdownMenuItem key={folder.id} onClick={() => onMove(folder.id)}>
                                    📁 {folder.name}
                                </DropdownMenuItem>
                            ))
                        }
                        {folders.length === 0 && !currentFolderId && (
                            <div className="px-2 py-1.5 text-sm text-muted-foreground">
                                No folders available
                            </div>
                        )}
                    </DropdownMenuContent>
                </DropdownMenu>

                <Button variant="destructive" size="sm" onClick={onDelete}>
                    <Trash2 className="h-4 w-4 mr-2" />
                    Delete
                </Button>

                <Button variant="ghost" size="sm" onClick={onClearSelection}>
                    <X className="h-4 w-4" />
                </Button>
            </div>
        </div>
    );
}